import { render, staticRenderFns } from "./SortItemEditor.vue?vue&type=template&id=c5a26a46&scoped=true"
import script from "./SortItemEditor.vue?vue&type=script&lang=js"
export * from "./SortItemEditor.vue?vue&type=script&lang=js"
import style0 from "./SortItemEditor.vue?vue&type=style&index=0&id=c5a26a46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a26a46",
  null
  
)

export default component.exports